<template>
  <!--Dialog-Import-Dependencies-->
  <v-dialog v-model="dialogImport" max-width="70%" scrollable>
    <v-card>
      <v-toolbar :flat="true" color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("strings.dialog-dependencies-title-conflict") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon="mdi-close" @click="closeImportFlow"> </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="importForm" v-model="validation" lazy-validation>
          <v-row no-gutters>
            <v-col cols="12">
              <div class="text-subtitle-1 mb-8">
                {{ $t("strings.dialog-dependencies-info-conflict") }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="processedDependenciesList"
                density="compact"
                class="primary-text"
                item-key="name"
                items-per-page="5"
              >
                <template v-slot:[`item.type`]="{ item }">
                  <span color="primary">{{
                    item.type
                      ? $t(`strings.dialog-dependencies-${item.type}`)
                      : ""
                  }}</span>
                  {{ item.type }}
                </template>
                <template v-slot:[`item.errors`]="{ item }">
                  <v-chip
                    v-for="(reason, index) in uniqueReasons(item)"
                    :key="index"
                    color="blue"
                    text-color="white"
                    class="mr-1"
                    size="small"
                  >
                    {{ $t(`strings.dialog-dependencies-${reason}`) }}
                  </v-chip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="d-flex justify-left">
                    <v-radio-group
                      v-model="item['chosenAction']"
                      defaults-target="new"
                      column
                      color="primary"
                      density="compact"
                    >
                      <v-radio
                        v-for="(dep, idx) in item.actions"
                        :key="idx"
                        :label="$t(`strings.import-action-${dep}`)"
                        :value="dep"
                        :disabled="isActionInErrors(item, dep)"
                        :false-icon="
                          isActionInErrors(item, dep)
                            ? 'mdi-circle-off-outline'
                            : 'mdi-radiobox-blank'
                        "
                      >
                        <template v-slot:label>
                          <span class="text-caption font-weight-medium">
                            {{ $t(`strings.import-action-${dep}`) }}
                          </span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" variant="text" @click="closeImportFlow">
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn
          color="secondary darken-1"
          variant="text"
          :disabled="isAllChosenActionSkip"
          @click="importFlowConfirm"
        >
          {{ $t("labels.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
export default {
  name: "DialogImportDependencies",
  mixins: [utils, events],
  props: ["dependenciesList", "dialogDependencies"],
  data: function () {
    return {
      menu: false,
      validation: true,
      headers: [
        { title: this.$t("labels.name"), key: "name", width: "auto" },
        { title: this.$t("labels.type"), key: "type", width: "auto" },
        { title: this.$t("labels.info"), key: "errors", width: "auto" },
        {
          title: "",
          sortable: false,
          align: "right",
          key: "actions",
          width: "auto",
        },
      ],
    };
  },
  computed: {
    dialogImport: {
      get() {
        return this.dialogDependencies;
      },
      set(value) {
        this.$emit("activateDialogDependencies", value);
      },
    },
    isAllChosenActionSkip() {
      return this.dependenciesList?.errors?.every((item) => {
        item.chosenAction === "skip";
      });
    },
    processedDependenciesList() {
      return this.dependenciesList?.errors?.map((item) => ({
        ...item,
        chosenAction: item.chosenAction || "new", // Set default to 'new' if 'chosenAction' does not exist
      }));
    },
  },

  methods: {
    uniqueReasons(item) {
      const allReasons = item.errors.flatMap((error) => error.reasons);
      return [...new Set(allReasons)];
    },
    isActionInErrors(item, action) {
      return item.errors.some((error) => error.action === action);
    },
    importFlowConfirm() {
      if (this.importValidateForm()) {
        this.createFormData();
      }
    },
    createFormData() {
      this.$emit("dependenciesActions", this.dependenciesList);
      this.closeImportFlow();
    },
    closeImportFlow() {
      this.dialogImport = false;
    },
    importValidateForm() {
      return this.$refs.importForm.validate();
    },
  },
};
</script>
